import styled from 'styled-components';

export const Coach = styled.div `
    width: 50%;
`